import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type UsableAccountPersonField =
  Database["public"]["Views"]["usable_account_person_fields"]["Row"];
export class SupabaseSegmentFieldService extends SupabaseServiceView<"usable_account_person_fields"> {
  table = "usable_account_person_fields" as const;
}
